// Auto-generated normalizer for table: Empleados_NivelJerarquico
export function empleadosNivelJerarquicoNormalize(row) {
  return {
    idEmpleadoNivelJerarquico: row.idEmpleadoNivelJerarquico ?? row.IdEmpleadoNivelJerarquico ?? row['IdEmpleadoNivelJerarquico'] ?? 0,
    idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? row['IdEmpleado'] ?? 0,
    idNivelJerarquico: row.idNivelJerarquico ?? row.IdNivelJerarquico ?? row['IdNivelJerarquico'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaAsignacion: row.fechaAsignacion ?? row.FechaAsignacion ?? row['FechaAsignacion'] ?? null,
  };
}
